import { SxStyleProp } from 'theme-ui';

export const style: { [k: string]: SxStyleProp } = {
  mainContainer: {
    margin: '54px auto 0px auto',
  },
  containerMobile: {
    display: 'flex',
    justifyContent: 'center',
  },
};
